export default __webpack_public_path__ + "static/media/Chat_alt_add_light.fc319169.svg";